/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MdCommonModule} from '@angular/material/core';
import {OverlayModule} from '@angular/cdk/overlay';
import {MdMenu, MD_MENU_DEFAULT_OPTIONS} from './menu-directive';
import {MdMenuItem} from './menu-item';
import {MdMenuTrigger, MD_MENU_SCROLL_STRATEGY_PROVIDER} from './menu-trigger';
import {MdRippleModule} from '@angular/material/core';
export class MdMenuModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    OverlayModule,
    CommonModule,
    MdRippleModule,
    MdCommonModule,
  ],
  exports: [MdMenu, MdMenuItem, MdMenuTrigger, MdCommonModule],
  declarations: [MdMenu, MdMenuItem, MdMenuTrigger],
  providers: [
    MD_MENU_SCROLL_STRATEGY_PROVIDER,
    {
      provide: MD_MENU_DEFAULT_OPTIONS,
      useValue: {
        overlapTrigger: true,
        xPosition: 'after',
        yPosition: 'below',
      },
    }
  ],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdMenuModule_tsickle_Closure_declarations() {
/** @type {?} */
MdMenuModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdMenuModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
